// item 1577 (Chad: "What happens if they've only shipped 3 of 4 items?") — a backorder can be
// PARTIAL: the line bills what shipped and `backorderedQty` says how many follow. The line's
// ordered total (quantity + to-follow) never changes while you move units between the two, so
// unticking always restores the full ordered quantity. The sales order's remaining-qty math
// (item 1484) reads the billed quantity, so the next invoice carries exactly the units to follow.

export interface BackorderSplit { quantity: number; backorderedQty: number | null; }

const round = (n: number) => Math.round(n * 100) / 100;

// tick the box: everything on the line follows (bill 0 now) — the item-1484b default
export const startBackorder = (quantity: number): BackorderSplit => {
  const q = Number(quantity) > 0 ? Number(quantity) : 1;
  return { quantity: 0, backorderedQty: q };
};

// change how many follow: clamp to 1..ordered, the rest bills now
export const setToFollow = (quantity: number, backorderedQty: number, toFollow: number): BackorderSplit => {
  const total = round((Number(quantity) || 0) + (Number(backorderedQty) || 0));
  const follow = Math.min(Math.max(round(Number(toFollow) || 0), 1), total > 0 ? total : 1);
  return { quantity: round(Math.max(total - follow, 0)), backorderedQty: follow };
};

// untick: bill the whole ordered quantity now
export const clearBackorder = (quantity: number, backorderedQty: number): BackorderSplit => {
  const total = round((Number(quantity) || 0) + (Number(backorderedQty) || 0));
  return { quantity: total > 0 ? total : 1, backorderedQty: null };
};
